import WebLayout from './ListRowLayout.web';
import MobileLayout from './ListRowLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
